import {Component, EventEmitter, ViewContainerRef} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ModalDismissReasons, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Configuration} from '../../shared/services/configuration';
import {HttpClientCustom} from '../../shared/services/http.client';
import {DomSanitizer} from '@angular/platform-browser';
import {FormBuilder} from '@angular/forms';
import {SharedData} from '../../shared/sharedData';
import {ToasterComponent} from '../../toasterComponent/toasterComponent';
import {ConfirmationComponent} from '../../confirmation/confirmation';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'ToolsMenu',
    templateUrl: 'userGroup.html',
    outputs: ['updateRate: hideMe']
})

export class UserGroupPage {
    closeResult: any;
    public updateRate: any = new EventEmitter();
    public pageSize: any = 10;
    public page = 1;
    public startingPage: any = 1;
    public endingPage: any = 10;
    public collectionSize: any;
    public asl: boolean = false;
    public showChild: boolean = false;
    public localState = { value: '' };
    public _baseUrl: any;
    public orgData: any = [];
    public trackHides = null;
    public designationModel: any;
    public organizationModel: any;
    public primarySupervisorModel: any;
    public employeeCode: any;
    public showAdvanceSearch: any = false;
    public userGroup: any = [];
    public userPageData: any = [];
    public showLoading: any = false;
    



    constructor(
        public route: ActivatedRoute,
        public modalService: NgbModal,
        public router: Router,
        public _global: Configuration,
        public http: HttpClientCustom,
        public share: SharedData,
        public _sanitizer: DomSanitizer,
        public builder: FormBuilder,
        public _toaster: ToasterComponent,
        public translate:TranslateService,
        public vcr: ViewContainerRef) {

        this._baseUrl = _global.get("EPMS_BASE_URL");
        this._toaster.setViewRef(vcr);
        this.getAllUSergroup();

    }

   //pagination functions
  onPageChange(event: number): void {
    let that = this;
    if (event == 1) {
      that.startingPage = 1;
      that.endingPage = 10;
    } else {
      that.startingPage = 1 + that.pageSize;
      if (that.collectionSize > that.endingPage) {
        that.endingPage = event + that.endingPage;
      } else {
        that.endingPage = that.collectionSize;
      }
    }
    that.page = event;
    that.getAllUSergroup();
  }
  OnPageSizeChanged(val) {
    this.pageSize = val;
    this.getAllUSergroup();
  }
    addUserGrp() {
        this.share.saveData({ desgId: null, type: 'ADD' });
        this.router.navigate(['menu/addUserGroup']);
    }

    addUsers(val) {
        this.share.saveData({ userGroup: val, type: 'ADDUSERS' });
        this.router.navigate(['menu/addUsersToGroup']);
    }

     deleteUsers(val) {
        this.share.saveData({ userGroup: val, type: 'DELETEUSERS' });
        this.router.navigate(['menu/addUsersToGroup']);
    }

    editUserGrp(val)
    {
        this.share.saveData({ userGroup: val, type: 'EDIT' });
        this.router.navigate(['menu/addUserGroup']);
    }
    deleteUserGrp(val)
    {
       
       this.userGroup=val;
       this.share.saveData({type: 'scaleRemove' });
        const modalRef = this.modalService.open(ConfirmationComponent, 
            { windowClass: 'min-modal' }).result.then((result) => {
                this.closeResult = `Closed with: ${result}`;
            if (result == 'confirmed') {
                this.deleteGroup();
            }
        }, (reason) => {
            this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
            this. getAllUSergroup() ;
        });
        
    }
    viewDetails(id) {
        this.share.saveData(id);
        this.router.navigate(['/menu/EmployeeInGroup']);
      }

    clicked()
    {
        this.trackHides=null;
    }

    public getDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
            return 'by pressing ESC';
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return 'by clicking on a backdrop';
        } else {
            return `with: ${reason}`;
        }
    }

    public deleteGroup() {
        let self = this;
        
        try {
            let url = self._baseUrl + "v1/hub/userGroup/" + self.userGroup.id;
            self.http.delete(url).subscribe(result => {
                if (result.success) {
                    self.translate.get('userGroupDeleted').subscribe((msg)=>{
                        self._toaster.showSuccess(msg)
                    });
                    this.getAllUSergroup() ;
                } else {
                    for (let val of result.errorMessages) {
                        self._toaster.showError(val);
                    }
                }
            });
        } catch (e) {
            self.translate.get('internalServerError').subscribe((msg)=>{
                self._toaster.showError(msg);
            })
            
        }
    }

    getAllUSergroup() {
        let self = this;
        try {
            self.showLoading = true;
            let url = self._baseUrl + "v1/hub/userGroup";
            // url += "?employeeId=" + 102;
            self.http.put(url,{ page: self.page, pageSize: self.pageSize }).subscribe(result => {
                self.userGroup = result.content;
                self.userPageData=result;
                if (self.userGroup.length == 0) {
                  self.showLoading = false;
                }
                self.collectionSize = result.totalElements;
                if (result.last) {
                  self.endingPage = self.collectionSize;
                }
            });
        } catch (e) {
            console.log("getAllUserGroup error catch", e);
        }
    }

    public empActions(val) {
        // this.hide = val;
    }
    public empTableActions(value) {
        if (this.trackHides == value) {
            this.trackHides = null;
        } else {
            this.trackHides = value;
        }

    }

    public onRefresh(){
        this.getAllUSergroup();    
    }

}



// WEBPACK FOOTER //
// ./src/app/tools/userGroup/userGroup.ts